import { WalletName } from '@aptos-labs/wallet-adapter-core'
import { AptosClient } from 'aptos'
import { CHAIN_NAME } from 'config/index'
import { create } from 'zustand'

export type ClaimWidgetClasses = {
  connectWalletButton: string
}

interface CommonConnectStore {
  claimUpdateTimestamp: null | number
  claimWidgetClasses: ClaimWidgetClasses
  client: AptosClient | null
  connectKey: null | WalletName
  setClaimWidgetClasses: (classes: ClaimWidgetClasses) => void
  setConnectKey: (connectKey: string) => void
  setShouldUpdateTimestamp: (shouldUpdateTimestamp: number) => void
}

const nodeUrl = `https://fullnode.${CHAIN_NAME}.aptoslabs.com/v1`
const client = new AptosClient(nodeUrl)

export const useCommonConnectStore = create<CommonConnectStore>((set) => ({
  claimUpdateTimestamp: null,
  claimWidgetClasses: {
    connectWalletButton: '',
  },
  client,
  connectKey: null,
  setClaimWidgetClasses: (claimWidgetClasses) => set({ claimWidgetClasses }),
  setConnectKey: (connectKey: WalletName) => set({ connectKey }),
  setShouldUpdateTimestamp: (claimUpdateTimestamp: number) => set({ claimUpdateTimestamp }),
}))
